function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FlipToggle =
/*#__PURE__*/
function () {
  function FlipToggle(node, flipAgent) {
    _classCallCheck(this, FlipToggle);

    this.node = node;
    this.flipAgent = flipAgent;
    this.targetNode = document.getElementById(this.node.getAttribute('data-target'));
    this.targetFlipNode = this.targetNode.parentNode.closest('.flip');
  }

  _createClass(FlipToggle, [{
    key: "closeOpenedToggle",
    value: function closeOpenedToggle() {
      if (this.isToggleOpened()) {
        this.closeToggle();
      }
    }
  }, {
    key: "closeToggle",
    value: function closeToggle() {
      this.makeInactive();
      this.flipAgent.makeInactive();
    }
  }, {
    key: "isToggleCloser",
    value: function isToggleCloser() {
      return this.node.matches('.flip__toggle_closer');
    }
  }, {
    key: "isToggleOpener",
    value: function isToggleOpener() {
      return this.node.matches('.flip__toggle_opener');
    }
  }, {
    key: "isToggleOpened",
    value: function isToggleOpened() {
      return this.node.matches('.flip__toggle_active');
    }
  }, {
    key: "makeInactive",
    value: function makeInactive() {
      this.node.classList.remove('flip__toggle_active');
      this.targetNode.classList.remove('flip__target_active');
      this.targetFlipNode.classList.remove('flip_active');
    }
  }, {
    key: "openToggle",
    value: function openToggle() {
      this.flipAgent.closeFlipOpenedToggles();
      this.node.classList.add('flip__toggle_active');
      this.targetNode.classList.add('flip__target_active');
      this.flipAgent.makeActive();
    }
  }, {
    key: "toggleToggle",
    value: function toggleToggle() {
      if (this.isToggleOpener()) return this.openToggle();
      if (this.isToggleCloser()) return this.closeToggle();
      if (this.isToggleOpened()) return this.closeToggle();
      return this.openToggle();
    }
  }]);

  return FlipToggle;
}();

export { FlipToggle as default };